// extracted by mini-css-extract-plugin
export default {"wrapper":"jJUqO","layout":"fkjke","point":"VxPAH","icon":"WO2NR","content":"u1H0U","time":"NSlB4"};